import { render, staticRenderFns } from "./c_additem.vue?vue&type=template&id=bc4c3d88&"
import script from "./c_additem.vue?vue&type=script&lang=js&"
export * from "./c_additem.vue?vue&type=script&lang=js&"
import style0 from "./c_additem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports